<div>
    <mat-form-field class="w-100">
        <mat-label *ngIf="placeHolder">{{placeHolder}}</mat-label>
        <mat-select class="w-100" name="answer_{{name}}" [(ngModel)]="selectValue" (ngModelChange)="onClick()"
            [disabled]="summaryMode" required matNativeControl>
            <mat-option *ngFor="let option of filter(options)" [value]="toValue(option)">{{toLabel(option)}}</mat-option>
        </mat-select>
    </mat-form-field>
    <div>
        <mat-error *ngIf="question?.invalid">required</mat-error>
    </div>
</div>